<div style="display: flex; flex-direction: column; max-height: 100%">
    <div>
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">{{ "DAILYCHECKS.title" | translate }}</span>
                    </div>
                </div>
                <mat-form-field style="height: 100%">
                    <mat-select [(ngModel)]="selectedAircraftOption" (selectionChange)="chooseAircraft($event.value)">
                        @for (item of aircraftOptions; track item) {
                            <mat-option [value]="item.value">{{ item.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div style="display: flex; flex-direction: row; height: 100%; overflow: hidden">
        <!--
      <div style="min-width: 200px; overflow-y: auto;">
        <mat-nav-list role="navigation" class="p-0">
          @for (helicopter of helicoptersArray; track $index) {
            <div (click)="chooseAircraft(helicopter)" class="aircraft" [ngClass]="{'is-active': helicopter.id === chosenAircraft?.id}">
              <div fxLayout="row">
                <mat-icon mat-list-icon class="m-15">flight_takeoff</mat-icon>
                <div mat-line class="mt-15" style="font-size: medium;">{{helicopter.registrationMark}}</div>
              </div>
            </div>
          }
        </mat-nav-list>
        <mat-divider [vertical]=true></mat-divider>
      </div>
      -->
        @if (chosenAircraft) {
            <app-daily-checks-table [aircraft]="chosenAircraft" />
        }
    </div>
</div>
